import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

/** Components */
import DataTable from '../../components/Table/DataTable';

// Utils
import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

// Services
import { getAllDuplicatedSubscribers } from '../../services/subscribers';

const DuplicatedSubscribers = (location) => {
  const dispatch = useDispatch();

  const [duplicatedSubscribers, setDuplicatedSubscribers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayDuplicatedSubscribers();
  }, [page, location]);

  const headers = ['email', 'uid', 'channelId'];

  const displayDuplicatedSubscribers = async () => {
    try {

      setIsLoading(true);
     
      const { data } = await getAllDuplicatedSubscribers(page);

      if (data.rows.length) {
        setDuplicatedSubscribers(data.rows);
        setTotalItems(data.count);
        setTotalPages(data.pages);
        setPage(data.page);
      } else {
        setDuplicatedSubscribers([]);
        setTotalItems(0);
      }
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };
  

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Duplicated Subscribers Count ({totalItems})</h1>
      </div>

      <DataTable
        useUid
        head={headers}
        body={duplicatedSubscribers}
        bodyColumn={headers}
        linkPath="subscribers"
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default DuplicatedSubscribers;
